var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(2485.078 17428.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(-2511 -17509.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(34.422 85.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M75,0A75,75,0,1,1,0,75,75,75,0,0,1,75,0Z",
    transform: "translate(0 0.088)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M59,0A59,59,0,1,1,0,59,59,59,0,0,1,59,0Z",
    transform: "translate(0 16.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M75,0A75,75,0,1,1,0,75,75,75,0,0,1,75,0Z",
    transform: "translate(0 0.088)",
    fill: "none",
    stroke: "#e78d00",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M-1177.879,170.446c-19.295,21.082-37.9,47.007-37.9,47.007s-2.426-7.037-3.818-10.481c-1.106-2.731-3.325-5.008-5-7.518a3.015,3.015,0,0,1-.547-1.52,21.157,21.157,0,0,1,4.63-13.947,5.992,5.992,0,0,1,6.15-2.5,21.366,21.366,0,0,0,14.8-3.139,18.068,18.068,0,0,0,4.991-4.711c2.026-2.889.635-5.567-2.824-6.22-4.932-.932-9.673.146-14.378,1.4-1.17.309-1.852.4-2.719-.751-2.394-3.168-7.116-4.111-11.542-2.574-1.706.594-3.389,1.316-5.136,1.735-3.745.9-6.3-1.345-5.591-5.142a10.293,10.293,0,0,1,2.493-4.909c4.641-4.9,10.646-6.482,17.209-6.418,6.622.07,12.637,2.236,18.455,5.195C-1191.005,159.812-1184.314,164.966-1177.879,170.446Zm-68.805,15.109c-1.336,1.994-.233,3.748.78,5.207a4.493,4.493,0,0,0,3.254,1.462c3.146.037,6.233.021,9.051,1.71,1.274.764,2.6,1.448,4.013,2.233.154-.771.3-1.331.374-1.9a23.685,23.685,0,0,1,9.583-16.891,7.4,7.4,0,0,0,1.3-1.155c1.2-1.45,1.812-3.3.8-4.821a5.5,5.5,0,0,0-3.678-2.122,13.25,13.25,0,0,0-5.225,1c-3.411,1.191-6.78,2.147-10.487.574C-1240.271,175.9-1243.458,180.739-1246.684,185.555Zm47.821-14.523c-3.448.508-6.889,1.073-10.345,1.507-2.819.354-4.407,1.722-4.312,4.892,5.66.056,10.906-.959,14.944-5.329Z",
    transform: "translate(1322.012 -23.104)",
    fill: "#e78d00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbb);
export default __webpack_public_path__ + "static/media/bbb.58890a97d6941d338e3ba8660c1ab00c.svg";
export { ForwardRef as ReactComponent };